var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-avatar',{attrs:{"size":"20px","src":`${require('@/assets/images/flags/en.png')}`},on:{"click":function($event){return _vm.updateLocale('en')}}}),_c('vs-avatar',{attrs:{"size":"20px","src":`${require('@/assets/images/flags/ar.png')}`},on:{"click":function($event){return _vm.updateLocale('ar')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }